import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    show: false,
    status: ReducerStatuses.IDLE,
    error: "",
    companyId: null,
    user: null
};

const slice = createSlice({
    name: "disassociateUser",
    initialState,
    reducers: {
        showDisassociateUserModal: (state, {payload}) => {
            state.show = true;
            state.companyId = payload.company;
            state.user = payload.user
        },
        hideDisassociateUserModal: (state) => {
            state.show = false;
            state.companyId = null;
            state.user = null;
        },
        startDisassociateUser: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        errorDisassociateUser: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        successDisassociateUser: (state) => {
            state.status = ReducerStatuses.SUCCESS;
            state.show = false;
            state.companyId = null;
            state.user = null;
        }
    }
});

const {reducer, actions} = slice;
export const {
    showDisassociateUserModal, errorDisassociateUser, hideDisassociateUserModal, startDisassociateUser, successDisassociateUser
} = actions;
export default reducer;